import { msg } from '@lingui/core/macro';

import { type ErrorByCodeType } from './types';

export const CANARY_ERROR_CODES = {
  PRODUCT_AREA_DETAILS_UNAVAILABLE: 'err:sol.canary.product-area-details-unavailable',
  PRODUCT_AREA_SETTINGS_REQUIRED: 'err:sol.canary.product-area-settings-required',
} as const;

export const CANARY_ERROR_MESSAGES_BY_CODE: ErrorByCodeType = {
  [CANARY_ERROR_CODES.PRODUCT_AREA_DETAILS_UNAVAILABLE]: msg`We were unable to generate product area information due to lack of a valid website or lack of content on the website.`,
  [CANARY_ERROR_CODES.PRODUCT_AREA_SETTINGS_REQUIRED]: msg`Configure and save valid product areas before triggering a Canary workflow.`,
};
